import { AText } from '@alf/uikit';
import { RESULT_TYPE_IDS, SPORT_IDS } from '../../../../constants';
import { useEventFields } from '../../../../store';

import styles from './index.module.css';

const EventStateLabel = ({ eventId }) => {
  const { sportId, eventResultId } = useEventFields({
    eventId,
    fields: ['sportId', 'eventResultId']
  });

  if (
    sportId === SPORT_IDS.VOLLEYBALL &&
    eventResultId === RESULT_TYPE_IDS.VOLLEYBALL_GOLDEN_SET
  ) {
    return (
      <AText size="xs" align="center" className={styles.label}>
        Golden Set
      </AText>
    );
  }

  return null;
};

export default EventStateLabel;
